// 由 EB view/admin/src/router/modules/statistic.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const statisticRouter: RouteRecordRaw = {
  path: `${roterPre}/statistic`,
  name: 'statistic',
  meta: {
    icon: 'dashboard',
    title: '统计'
  },
  alwaysShow: true,
  component: Layout,
  children: [
    {
      path: 'order',
      name: 'statisticOrder',
      meta: {
        title: '订单统计'
      },
      component: () => import('@/views/statistic/order/index.vue')
    },
    //商品统计
    {
      path: 'product',
      name: 'statisticProduct',
      meta: {
        title: '商品统计'
      },
      component: () => import('@/views/statistic/product/index.vue')
    },
    //会员统计
    {
      path: 'member',
      name: 'statisticMember',
      meta: {
        title: '用户统计'
      },
      component: () => import('@/views/statistic/user/index.vue')
    },
  ]
}

export default statisticRouter;
